module.exports = __webpack_public_path__ + "img/qr_background.7326a7ee.png";